import {mapStore} from "../util/mapStore.js";
import React, {useLayoutEffect, useMemo, useState} from "../_snowpack/pkg/react.js";
import {Avatar, List, Space} from "../_snowpack/pkg/antd.js";
import {
  FacebookOutlined,
  GlobalOutlined,
  InstagramOutlined,
  LinkedinOutlined,
  PhoneOutlined,
  WhatsAppOutlined
} from "../_snowpack/pkg/@ant-design/icons.js";
import {useTranslation} from "../_snowpack/pkg/react-i18next.js";
import {formatRupiah} from "../services/Formatters.js";
const vendors = [
  {
    icon: "assets/vendors/smartenergytech/icon.png",
    description: "Have your own smart solar energy system, anywhere in Indonesia.",
    name: "Smart Energy Tech",
    location: {
      lat: -8.6728578,
      lng: 115.2563974
    },
    details: {
      phone: "+62 812-3742-6724",
      address: "Jl. Bypass Ngurah Rai No.180, Denpasar, Bali",
      link: "https://www.smartenergy.tech/solar-panel-indonesia",
      instagram: "https://www.instagram.com/smartenergy.tech/",
      whatsapp: "https://wa.me/6281237426724"
    }
  },
  {
    icon: "assets/vendors/bti/icon.png",
    description: "Hemat Tagihan Listrik Sayangi Lingkungan Bersama BTI Energy.",
    name: "BTI Solar Panel di Bali",
    location: {
      lat: -8.6728578,
      lng: 115.2563974
    },
    details: {
      link: "https://btienergy.id/",
      phone: "+62 819-1671-7995",
      address: "Jl. Antasura No.50 Denpasar Denpasar, Bali",
      instagram: "https://www.instagram.com/bti.energy/",
      facebook: "https://www.facebook.com/BTI.energy/",
      whatsapp: "https://wa.me/6281916717995"
    }
  },
  {
    icon: "assets/vendors/taiyo/icon.png",
    description: "Listrik surya hijaukan dunia.\n TakaEnergi merupakan bagian dari PT Taiyo Global Persada Energi.",
    name: "TakaEnergi",
    location: {
      lat: -6.2486205,
      lng: 106.8812313
    },
    details: {
      link: "http://www.taiyoglobal.com/",
      phone: "+62 895-33814-2626",
      address: "Graha Inspirasi. Jalan Manunggal Pratama No. 8, Jakarta",
      linkedin: "https://www.linkedin.com/company/taiyo-global-persada-energi/",
      whatsapp: "https://wa.me/62895338142626"
    }
  },
  {
    icon: "assets/vendors/fsi/icon.png",
    description: "French Solar Industry produces its own panels with the latest technology, performance and warranties on the market.",
    name: "French Solar Industry",
    location: {
      lat: -8.7039336,
      lng: 115.1738993
    },
    details: {
      link: "https://frenchsolarindustry.com/",
      phone: "+62 812-3687-9516",
      address: "Jalan Dewi Sri II A, Legian, Kuta Bali 80361",
      facebook: "https://www.facebook.com/French-Solar-Industry-445018702701046/",
      whatsapp: "https://wa.me/6281236879516"
    }
  }
];
const asin = Math.asin;
const cos = Math.cos;
const sin = Math.sin;
const PI_180 = Math.PI / 180;
function hav(x) {
  const s = sin(x / 2);
  return s * s;
}
function relativeHaversineDistance(a, b) {
  const aLatRad = a.lat * PI_180;
  const bLatRad = b.lat * PI_180;
  const aLngRad = a.lng * PI_180;
  const bLngRad = b.lng * PI_180;
  const ht = hav(bLatRad - aLatRad) + cos(aLatRad) * cos(bLatRad) * hav(bLngRad - aLngRad);
  return asin(ht);
}
const toMessage = (t, connectionPower, position, result, address) => {
  if (result) {
    const {numberOfPanels, currentMonthlyCosts} = result;
    const monthlyCosts = formatRupiah(currentMonthlyCosts);
    const urlWithParams = new URL(window.location.href);
    const params = new URLSearchParams();
    params.set("cp", `${connectionPower}`);
    params.set("me", `${currentMonthlyCosts}`);
    params.set("lat", `${position.lat}`);
    params.set("long", `${position.lng}`);
    const webLink = urlWithParams.origin + urlWithParams.pathname + "?enc=" + encodeURIComponent(`${params}`);
    return encodeURI(t("vendors.message", {numberOfPanels, address, monthlyCosts, connectionPower, webLink}));
  }
  return "";
};
export const VendorList = ({resultData, connectionPower}) => {
  const {t} = useTranslation();
  const [position, setPosition] = useState(void 0);
  const [address, setAddress] = useState(void 0);
  const sortedVendors = useMemo(() => {
    if (position) {
      return vendors.sort((a, b) => relativeHaversineDistance(a.location, position) - relativeHaversineDistance(b.location, position));
    } else
      return [];
  }, [position]);
  useLayoutEffect(() => {
    mapStore.subscribe((state) => {
      setPosition(state.location);
      setAddress(state.address);
    });
  }, []);
  if (!position)
    return /* @__PURE__ */ React.createElement(React.Fragment, null);
  return /* @__PURE__ */ React.createElement(List, {
    itemLayout: "vertical",
    size: "large",
    dataSource: sortedVendors,
    renderItem: (item) => /* @__PURE__ */ React.createElement(List.Item, {
      key: item.name,
      actions: [
        /* @__PURE__ */ React.createElement(Space, null, /* @__PURE__ */ React.createElement("a", {
          href: `tel: ${item.details.phone}`
        }, /* @__PURE__ */ React.createElement(PhoneOutlined, {
          style: {fontSize: "16px"}
        }))),
        /* @__PURE__ */ React.createElement(Space, null, /* @__PURE__ */ React.createElement("a", {
          href: item.details.link,
          target: "_blank"
        }, /* @__PURE__ */ React.createElement(GlobalOutlined, {
          style: {fontSize: "16px"}
        }))),
        item.details.instagram ? /* @__PURE__ */ React.createElement(Space, null, /* @__PURE__ */ React.createElement("a", {
          href: item.details.instagram,
          target: "_blank"
        }, /* @__PURE__ */ React.createElement(InstagramOutlined, {
          style: {fontSize: "16px"}
        }))) : void 0,
        item.details.facebook ? /* @__PURE__ */ React.createElement(Space, null, /* @__PURE__ */ React.createElement("a", {
          href: item.details.facebook,
          target: "_blank"
        }, /* @__PURE__ */ React.createElement(FacebookOutlined, {
          style: {fontSize: "16px"}
        }))) : void 0,
        item.details.linkedin ? /* @__PURE__ */ React.createElement(Space, null, /* @__PURE__ */ React.createElement("a", {
          href: item.details.linkedin,
          target: "_blank"
        }, /* @__PURE__ */ React.createElement(LinkedinOutlined, {
          style: {fontSize: "16px"}
        }))) : void 0,
        item.details.whatsapp ? /* @__PURE__ */ React.createElement(Space, null, /* @__PURE__ */ React.createElement("a", {
          href: `${item.details.whatsapp}?text=${toMessage(t, connectionPower, position, resultData, address)}`,
          target: "_blank"
        }, /* @__PURE__ */ React.createElement(WhatsAppOutlined, {
          style: {fontSize: "16px"}
        }))) : void 0
      ].filter((x) => x !== void 0)
    }, /* @__PURE__ */ React.createElement(List.Item.Meta, {
      avatar: /* @__PURE__ */ React.createElement(Avatar, {
        shape: "square",
        src: item.icon
      }),
      title: /* @__PURE__ */ React.createElement("a", {
        href: item.details.link
      }, item.name),
      description: item.description
    }))
  });
};
